export default __webpack_public_path__ + "c14da6342514c2f5f458eb7a5ceca062.svg";